import WcAsset from './WcAsset.vue'
var VueTouch = require('vue-touch');

WcAsset.install = function(Vue){
	Vue.component(WcAsset.name,WcAsset)
	Vue.use(VueTouch,{name:'v-touch'})
}
export default WcAsset



// WEBPACK FOOTER //
// ./src/components/asset/asset/index.js